import LoginForm from "./components/LoginForm";
import LoginHeading from "./components/LoginHeading";

const Login = () => {
  return (
    <div className="h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <LoginHeading />
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
